import React from 'react';
import "./GridSection.css"
import useIntersectionObserver from "../customHooks/useIntersectionObserver.js";
const GridSection = () => {
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <section className={`grid-cards-section ${isVisible ? "section-animation" : ""}`}
            ref={ref}
            id="four"
        >
            <div className="container">
                <div className="content-tag">
                    <h2 className='colored-text'>Solutions</h2>
                </div>
                <div className="grid-cards-heading">
                    <h2>Tailored Solution with Akira AI AgentScrum</h2>
                    <p>AgentScrum is designed to act as a virtual Scrum Master, automating and optimizing every phase of the Scrum lifecycle. It delivers a tailored, intelligent, and proactive solution to support high-performing agile teams</p>
                </div>
                <div className="row grid-card-row">
                    <div className="col-12 grid-cards-wrapper">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                                <div className="grid-first-card">
                                    <h3>Backlog Optimization</h3>
                                    <h2 className="card-heading">Intelligent Backlog Management</h2>
                                    <p className="card-paragraph">
                                        Monitors and refines backlog using smart prioritization, dependency checks, and effort-value analysis to streamline planning and ensure clarity
                                    </p>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 grid-image-wrapper">
                                <div className="grid-first-card-image">
                                    <img
                                        src="https://www.xenonstack.com/hubfs/streaming-data-platform-1.svg"
                                        alt="streaming-data-platform"
                                        loading="lazy"
                                        width="340"
                                        height="283"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 second-column">
                        <div className="grid-second-cards-wrapper">
                            <div className="grid-first-card">
                                <h3>Sprint Setup </h3>
                                <h2 className="card-heading">Smart Sprint Planning </h2>
                                <p className="card-paragraph">
                                    Creates sprint goals, breaks down tasks, estimates workloads, and balances capacity to enable effective planning and workload distributio
                                </p>
                            </div>
                            <div className="grid-second-card-image">
                                <img
                                    src="https://www.akira.ai/hubfs/audience-insight-agents.svg"
                                    alt="data-lakehouse"
                                    loading="lazy"
                                    width=""
                                    height=""
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>

                        <div className="grid-third-card">
                            <h3>Sprint Tracking </h3>
                            <h2 className="card-heading">Sprint Execution Monitoring </h2>
                            <p className="card-paragraph">
                                Monitors velocity, cycle time, scope, and progress; visualizes real-time metrics and alerts teams to risks or deviations instantly
                            </p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 third-column">
                        <div className="grid-fourth-card">
                            <h3>Daily Sync</h3>
                            <h2 className="card-heading">Real-Time Daily Scrum Facilitation </h2>
                            <p className="card-paragraph">
                                Prepares structured standups with agenda, tracks task updates, highlights blockers, and keeps team progress aligned with sprint objectives
                            </p>
                        </div>

                        <div className="grid-last-card-wrapper">
                            <div className="grid-first-card">
                                <h3>Blocker Resolution </h3>
                                <h2>Automated Impediment Management</h2>
                                <p className="card-paragraph">
                                    Detects, logs, categorizes, and escalates impediments, suggesting resolutions and notifying relevant stakeholders for quicker issue resolution
                                </p>
                            </div>
                            <div className="grid-last-card-image">
                                <img
                                    src="https://www.xenonstack.com/hubfs/cloud-data-warehouse.svg"
                                    alt="cloud-data-warehouse"
                                    loading="lazy"
                                    width="377"
                                    height="352"
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GridSection;
